<template>
  <svg
    height="47"
    viewBox="0 0 45 47"
    width="45"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      fill="#fff"
    ><path
      d="m0 .697h44.3037v44.3026h-44.3037z"
      fill="#fff"
      fill-rule="evenodd"
    /></mask>
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="m44.3037 22.8486c0 12.235-9.918 22.151-22.152 22.151-12.235 0-22.152-9.916-22.152-22.151s9.917-22.152 22.152-22.152c12.234 0 22.152 9.917 22.152 22.152"
        fill="#fff"
        mask="url(#a)"
        transform="translate(0 .3032)"
      />
      <path
        d="m44.0127 23.1494c0-12.073-9.789-21.861-21.861-21.861-7.587 0-14.269 3.867-18.189 9.735l18.189 12.126z"
        fill="#fff"
      />
      <path
        d="m44.0127 23.1494h-21.861l-18.189 12.126c3.92 5.868 10.602 9.734 18.189 9.734 12.072 0 21.861-9.786 21.861-21.86"
        fill="#d7141a"
      />
      <path
        d="m3.9624 11.0234c-2.319 3.471-3.672 7.64-3.672 12.126s1.353 8.655 3.672 12.126l18.189-12.126z"
        fill="#11457e"
      />
    </g>
  </svg>
</template>
